// Client-side gates for the D2C dashboard. They only hide or lock the screen;
// the OMS refuses the ops API itself for anyone who is not a super admin or
// does not hold `d2c-ops`, and refuses a switch change without `d2c-switches`.
export const D2C_OPS_PERMISSION = "d2c-ops";
export const D2C_SWITCHES_PERMISSION = "d2c-switches";

const grants = (entry, permission) =>
  typeof entry?.API === "string" &&
  entry.API.split(",").some((name) => name.trim() === permission);

const hasPermission = (selfInfo, permission) => {
  const user = selfInfo?.user;
  if (!user) return false;
  if (user.user_type === "super_admin") return true;
  return Object.values(user.permissions_access || {}).some(
    (section) => Array.isArray(section) && section.some((entry) => grants(entry, permission)),
  );
};

export const hasD2cOpsAccess = (selfInfo) => hasPermission(selfInfo, D2C_OPS_PERMISSION);

// May change the routing switches (the OMS also needs d2c-ops to reach them).
export const hasD2cSwitchesAccess = (selfInfo) => hasPermission(selfInfo, D2C_SWITCHES_PERMISSION);
